/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TranslationChangedResult } from '../../models/translation-changed-result';

export interface GithubTranslationsControllerHandleEnglishTranslationsChanged$Params {
  appId: string;
}

export function githubTranslationsControllerHandleEnglishTranslationsChanged(http: HttpClient, rootUrl: string, params: GithubTranslationsControllerHandleEnglishTranslationsChanged$Params, context?: HttpContext): Observable<StrictHttpResponse<TranslationChangedResult>> {
  const rb = new RequestBuilder(rootUrl, githubTranslationsControllerHandleEnglishTranslationsChanged.PATH, 'get');
  if (params) {
    rb.path('appId', params.appId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TranslationChangedResult>;
    })
  );
}

githubTranslationsControllerHandleEnglishTranslationsChanged.PATH = '/github-translations/{appId}/englishTranslationsChanged';
